<div class="dot-container">
  <div class="dot"></div>
  <div class="dot"></div>
  <div class="dot"></div>
</div>
